export default __webpack_public_path__ + "static/media/heroImage.8e970f7a.png";